//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { ParentSignupInputItem } from './ParentSignupInputItem';
import { StudentSignupInputItem } from './StudentSignupInputItem';
import { PaymentSourceInputItem } from './PaymentSourceInputItem';

export class SignupInputItem extends ItemBase {
    WebsiteBlockID: string | null = null;
    Parent: ParentSignupInputItem | null = null;
    Student: StudentSignupInputItem | null = null;
    PaymentSource: PaymentSourceInputItem | null = null;
    Captcha: string | null = null;

    constructor(initializer?: Partial<SignupInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "SignupInputItem";
}
